// src/modules/app-views/omnichannel/pages/Init/components/ConversationOverlay.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Spin, Button, Flex, Tooltip } from 'antd';
import { SwapOutlined } from '@ant-design/icons';
import { MdOutlineSupportAgent, MdOutlineWhatsapp } from 'react-icons/md';
import { HiOutlineArchiveBoxArrowDown, HiOutlineArchiveBoxXMark } from 'react-icons/hi2';
import translateX from 'utils/translateX';
import appService from 'services/appService';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************

// Unified overlay for conversation loading and queue state.
// States:
//   1. loading=true           → blur + spinner (loading conversation data)
//   2. loading=false, queue   → blur + attend/distribute buttons
//   3. loading=false, assigned → hidden (null)
const ConversationOverlay = ({
  loading,
  isInQueue,
  isArchived,
  isDark,
  onAttend,
  attendLoading,
  onDistribute,
  onArchive,
  noWhatsapp,
}) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────
  // Hide completely when not loading and conversation is assigned to an agent
  if (!loading && !isInQueue && !noWhatsapp) return null;

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <div
      style={{
        position: 'absolute',
        inset: 0,
        backgroundColor: isDark ? 'rgba(0, 0, 0, 0.45)' : 'rgba(255, 255, 255, 0.45)',
        backdropFilter: 'blur(10px)',
        WebkitBackdropFilter: 'blur(10px)',
        zIndex: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'opacity 0.2s ease',
      }}
    >
      {loading ? (
        <Spin size="large" />
      ) : noWhatsapp ? (
        <Flex vertical align="center" gap={12} style={{ opacity: 0.55 }}>
          <MdOutlineWhatsapp style={{ fontSize: 52, color: '#25D366' }} />
          <span style={{ fontSize: 15 }}>{translateX('contact_has_no_whatsapp')}</span>
        </Flex>
      ) : (
        <Flex gap={12} vertical={!appService.isDesktop()} align="center">
          {isArchived ? (
            <Tooltip title={translateX('unarchive_conversation')}>
              <Button
                type="primary"
                size="large"
                icon={<HiOutlineArchiveBoxXMark style={{ fontSize: 18, display: 'flex' }} />}
                onClick={onArchive}
              >
                {translateX('unarchive')}
              </Button>
            </Tooltip>
          ) : (
            <>
              <Tooltip title={translateX('assign_conversation_to_me')}>
                <Button
                  type="primary"
                  size="large"
                  loading={attendLoading}
                  disabled={attendLoading}
                  icon={!attendLoading && <MdOutlineSupportAgent style={{ fontSize: 18, display: 'flex' }} />}
                  onClick={onAttend}
                >
                  {translateX('attend')}
                </Button>
              </Tooltip>
              {/*<Tooltip title={translateX('assign_conversation_to_other')}>*/}
              {/*  <Button*/}
              {/*    type="primary"*/}
              {/*    size="large"*/}
              {/*    icon={<SwapOutlined />}*/}
              {/*    onClick={onDistribute}*/}
              {/*  >*/}
              {/*    {translateX('distribute')}*/}
              {/*  </Button>*/}
              {/*</Tooltip>*/}
              <Tooltip title={translateX('archive_conversation')}>
                <Button
                  size="large"
                  icon={<HiOutlineArchiveBoxArrowDown style={{ fontSize: 18, display: 'flex' }} />}
                  onClick={onArchive}
                >
                  {translateX('archive')}
                </Button>
              </Tooltip>
            </>
          )}
        </Flex>
      )}
    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default ConversationOverlay;
